export default __webpack_public_path__ + "static/media/final-logos-white-03.dc597992.png";